/* The mockup's `.editor`, `.conv` width, `.divider` and `.pv`. */
.workspace {
  --conversation-width: 360px;

  display: flex;
  flex: 1;
  min-block-size: 0;
}

.conversation {
  display: flex;
  flex: none;
  flex-direction: column;
  inline-size: var(--conversation-width);
  min-block-size: 0;
  background: var(--surface-raised);
}

.conversation[hidden] {
  display: none;
}

/* A 9px hit area over a 1px hairline that turns accent on hover, focus and drag. */
.divider {
  position: relative;
  z-index: 2;
  flex: none;
  inline-size: 9px;
  margin: 0 -4px;
  cursor: col-resize;
  touch-action: none;
}

.divider::before {
  content: "";
  position: absolute;
  inset-block: 0;
  inset-inline-start: 4px;
  inline-size: 1px;
  background: var(--border);
  transition:
    background var(--motion-duration) var(--motion-ease),
    inline-size var(--motion-duration) var(--motion-ease);
}

.divider:hover::before,
.divider:focus-visible::before,
.divider[data-dragging="true"]::before {
  inset-inline-start: 3.5px;
  inline-size: 2px;
  background: var(--focus-ring);
}

.divider:focus-visible {
  outline: none;
}

.preview {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-inline-size: 0;
  min-block-size: 0;
  background: var(--canvas);
}

.workspace[data-layout="stacked"] {
  flex-direction: column;
}

.workspace[data-layout="stacked"] .conversation {
  inline-size: 100%;
  block-size: 46%;
  border-bottom: 1px solid var(--border);
}

/* The collapsed conversation (owner report, round 3): a 48px rail with the way back on top. */
.rail {
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  inline-size: 48px;
  padding-block: var(--space-2);
  border-inline-end: 1px solid var(--border);
  background: var(--surface-raised);
}

.workspace[data-layout="stacked"] .rail {
  flex-direction: row;
  inline-size: 100%;
  block-size: 48px;
  padding: 0 var(--space-2);
  border-inline-end: 0;
  border-bottom: 1px solid var(--border);
}
